module.exports = __webpack_public_path__ + "static/media/pre_cast_sla_bea.f1df7478.png";